var _path, _line, _line2, _line3, _line4, _line5, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationTapToStack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 179,
    viewBox: "0 0 296 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M283 163.5H269.5H257C253.5 163.5 251.5 160.5 249.5 158C247.5 155.5 231.5 127.5 229.5 123.5C227.5 119.5 228.5 116.5 230 115.5C231.5 114.5 234.5 115 236.5 116.5C238.5 118 244 128 248.5 128C252.1 128 253.667 126 254 125C254.333 115.667 255 96.2 255 93C255 89 256 74.5 256 72.5C256 70.5 257 67.5 261 67.5C264.2 67.5 265.333 70.8333 265.5 72.5L268 108C273.167 110.5 284.4 116.1 290 118.5C295.6 120.9 295.667 126.167 295 128.5C294.333 134.167 292.7 147.4 291.5 155C290.3 162.6 285.333 163.833 283 163.5Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 261,
    y1: 50,
    x2: 261,
    y2: 57,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 242.378,
    y1: 60.682,
    x2: 248.682,
    y2: 64.622,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 242.389,
    y1: 81.6402,
    x2: 249.64,
    y2: 77.6115,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 272.378,
    y1: 77.682,
    x2: 278.682,
    y2: 81.622,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 279.682,
    y1: 60.378,
    x2: 273.378,
    y2: 64.318,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 125.5L74.5 178.5V166.5L1 113.5V125.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 178.5L147.5 125.5V113.5L74.5 166.5V178.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 62L1 113.5L74.5 166.5L147.5 113.5L74.5 62Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 178.5L1 125.5V113.5M74.5 178.5L147.5 125.5V113.5M74.5 178.5V166.5M1 113.5L74.5 62L147.5 113.5M1 113.5L74.5 166.5M74.5 166.5L147.5 113.5",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 113.5L74.5 166.5V154.5L1 101.5V113.5Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 166.5L147.5 113.5V101.5L74.5 154.5V166.5Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 50L1 101.5L74.5 154.5L147.5 101.5L74.5 50Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 166.5L1 113.5V101.5M74.5 166.5L147.5 113.5V101.5M74.5 166.5V154.5M1 101.5L74.5 50L147.5 101.5M1 101.5L74.5 154.5M74.5 154.5L147.5 101.5",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1 101.5L74.5 154.5V142.5L1 89.5V101.5Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 154.5L147.5 101.5V89.5L74.5 142.5V154.5Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 38L1 89.5L74.5 142.5L147.5 89.5L74.5 38Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 154.5L1 101.5V89.5M74.5 154.5L147.5 101.5V89.5M74.5 154.5V142.5M1 89.5L74.5 38L147.5 89.5M1 89.5L74.5 142.5M74.5 142.5L147.5 89.5",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35 64.5L108.5 117.5V105.5L35 52.5V64.5Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 117.5L181.5 64.5V52.5L108.5 105.5V117.5Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 1L35 52.5L108.5 105.5L181.5 52.5L108.5 1Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 117.5L35 64.5V52.5M108.5 117.5L181.5 64.5V52.5M108.5 117.5V105.5M35 52.5L108.5 1L181.5 52.5M35 52.5L108.5 105.5M108.5 105.5L181.5 52.5",
    stroke: "white",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationTapToStack);
export default __webpack_public_path__ + "static/media/illustration_tap-to-stack.544538a5277f40e49f670bb3cead2b17.svg";
export { ForwardRef as ReactComponent };